import { render, staticRenderFns } from "./UtilityEmptyLink.vue?vue&type=template&id=799d3bfc&scoped=true"
import script from "./UtilityEmptyLink.vue?vue&type=script&lang=js"
export * from "./UtilityEmptyLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799d3bfc",
  null
  
)

export default component.exports